// 一些公共过滤
/** 组别数字变成文字
 * @method groupType
 * @param {string, number} val 
 */
export const groupType = (val) => {
  switch (val * 1) {
    case 3:
      return 'AS'
    case 4:
      return 'DR'
    case 25:
      return 'Honor'         // 荣誉组
    case 26:
      return 'Scholastic'    // 学者组
    case 27:
      return 'Varsity'       // 队打组
    case 32:
      return 'Honor'         // 荣誉组
    case 33:
      return 'Scholastic'    // 学者组
    case 34:
      return 'Varsity'       // 队打组
    case 35:
      return 'Honor'         // 荣誉组
    case 36:
      return 'Scholastic'    // 学者组
    case 37:
      return 'Varsity'       // 队打组
    case 44:
      return 'AS'            // AS(高级组别)
    case 45:
      return 'DR'            // DR(初级组别)
    case 46:
      return 'Pre'           // Pre(入门组别)
    default:
      return ''
  }
}



// WEBPACK FOOTER //
// ./src/filters/common.js